import { atom } from "recoil";

export const DataDuAnState = atom({
  key: "DataDuAnState",
  default: undefined,
});
